export default {
  formId: 'createTipoNovedadForm', //'createTipoNovedadForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre*',
      requiredErrorMsg: 'Nombre es requerido.',
    },
    description: {
      name: 'description',
      label: 'Descripcion*',
      requiredErrorMsg: 'Descripcion es requerido.',
    },
    accion_1: {
      name: 'accion_1',
      label: 'Accion 1*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    resultado_1: {
      name: 'resultado_1',
      label: 'Resultado 1*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    cantidad_1: {
      name: 'cantidad_1',
      label: 'Cantidad 1*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    accion_2: {
      name: 'accion_2',
      label: 'Accion 2*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    resultado_2: {
      name: 'resultado_2',
      label: 'Resultado 2*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    cantidad_2: {
      name: 'cantidad_2',
      label: 'Cantidad 2*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    accion_3: {
      name: 'accion_3',
      label: 'Accion 3*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    resultado_3: {
      name: 'resultado_3',
      label: 'Resultado 3*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    cantidad_3: {
      name: 'cantidad_3',
      label: 'Cantidad 3*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
    accion_4: {
      name: 'accion_4',
      label: 'Accion 4*',
      requiredErrorMsg: 'Accion es requerido.',
    },
    resultado_4: {
      name: 'resultado_4',
      label: 'Resultado 4*',
      requiredErrorMsg: 'Resultado es requerido.',
    },
    cantidad_4: {
      name: 'cantidad_4',
      label: 'Cantidad 4*',
      requiredErrorMsg: 'Cantidad es requerido.',
    },
  },
};
